import React from 'react';

import { styled } from '@mui/material/styles';

import RatingIcon from '~/assets/icons/RatingIcon';
import { BodyText, H3 } from '~/components/UI/Texts';
import useTenantTranslation from '~/hooks/useTenantTranslation';
import useIconAnimation from '~/libs/hooks/animations/useIconAnimation';
import { MIDDLE_MARGIN_PX, MIDDLE_RADIUS_PX, SMALL_MARGIN_PX, SUBMIDDLE_MARGIN_PX } from '~/theme';

const CommentReviewCard = () => {
  const { t } = useTenantTranslation();
  const { scope, play } = useIconAnimation('RatingIcon');

  return (
    <Wrapper data-testid="commentApprovalWaitingMessage">
      <StyledRatingIcon ref={scope} onMouseEnter={play} />
      <div>
        <H3>{t('page.video.thanksForYourFeedback')}</H3>
        <BodyText>{t('page.video.thanksForYourFeedbackDesc')}</BodyText>
      </div>
    </Wrapper>
  );
};

export default CommentReviewCard;

const Wrapper = styled('div')`
  position: relative;
  padding: ${SUBMIDDLE_MARGIN_PX};
  margin-bottom: ${MIDDLE_MARGIN_PX};
  display: flex;
  align-items: center;
  border-radius: ${MIDDLE_RADIUS_PX};
  background: ${({ theme }) => theme.palette.common.blackSecondary};
`;
const StyledRatingIcon = styled(RatingIcon)`
  width: 48px;
  min-width: 48px;
  height: 48px;
  margin-right: ${SMALL_MARGIN_PX};
`;
